/* Ayudate · Input de contraseña con botón para mostrar/ocultar el texto.
   Envuelve un <input> normal: recibe las mismas props (id, className,
   value, onChange, autoComplete, aria-*, etc.) y solo agrega el ojo. */

import React, { useState } from "react";

function IconoOjo() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M2 12s3.8-7 10-7 10 7 10 7-3.8 7-10 7-10-7-10-7Z"
        fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

function IconoOjoTachado() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M2 12s3.8-7 10-7 10 7 10 7-3.8 7-10 7-10-7-10-7Z"
        fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M3.5 3.5l17 17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function CampoPassword({ className, ...props }) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="campo-pass">
      <input {...props} type={visible ? "text" : "password"} className={className} />
      <button type="button" className="pass-toggle" onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"} aria-pressed={visible}>
        {visible ? <IconoOjoTachado /> : <IconoOjo />}
      </button>
    </div>
  );
}
